import { render, staticRenderFns } from "./AboutManage.vue?vue&type=template&id=94e991ee&scoped=true&"
import script from "./AboutManage.vue?vue&type=script&lang=js&"
export * from "./AboutManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e991ee",
  null
  
)

export default component.exports